import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { WelcomeTourDialogComponent } from '@go-modules/components/dialogs/welcome-tour-dialog/welcome-tour-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		A11yModule
	],
	declarations: [
		WelcomeTourDialogComponent
	],
	exports: [
		WelcomeTourDialogComponent
	]
})
export class WelcomeTourDialogModule {}
